export enum InvestigationQuestionStatus {
	New = 1,
	Scheduled = 2,
	Sent = 3,
	Answered = 4,
	NotAnswered = 5,
	AskedInSession = 6,
}
